import * as VitaloJak2Api from '../../../misc/api/DeviceLinkApi/VitaloJak2';
import * as VitaloJak2Messages from '../../../misc/api/DeviceLinkApi/VitaloJak2Messages';
import { Device } from '../../../misc/api/DeviceLinkApi/Devices';
import { QueryCondition } from '../../../misc/api/apiTypes';
import { StudyScheduleSession, WebPortalClient, Subject } from 'webportalclient';
import { WebPortalLegacyClientInternal } from '../../../misc/api/WebPortalTokenClient';


export const VitaloJak2CheckExistingData = async (client: WebPortalClient, legacyClient: WebPortalLegacyClientInternal, subjectParam: Subject, device: Device, subjectId: string, selectedSessions: StudyScheduleSession[], hasForceReconfigurePermission: boolean, raiseConfigurationError: (message: string, isWarning: boolean) => void) => {
    const dataCheck = await VitaloJak2Api.ApiCheckData(device.id);
    const subject = await VitaloJak2Api.ApiGetSubject(device.id);

    const currentStudyId = subjectParam.site.studyId;

    const deviceId = device.id;

    const studyOnDevice = await VitaloJak2Api.ApiGetStudy(deviceId);
    const subjectOnDevice = await VitaloJak2Api.ApiGetSubject(deviceId);
    const siteOnDevice = await VitaloJak2Api.ApiGetSite(deviceId);
    
    const getStudy = await client.getStudy(currentStudyId);

    const getSubject = await client.getSubject(subjectParam.id);

    if (studyOnDevice.studyId.trim().length > 0) {
        if (!(studyOnDevice.studyId.includes(getStudy.protocol)) && !(subjectOnDevice.subjectId.includes(getSubject.number)) && !hasForceReconfigurePermission) {

            raiseConfigurationError(VitaloJak2Messages.ReconfigureBlockedFromOtherStudyMessage(subjectOnDevice.subjectId, siteOnDevice.siteId, studyOnDevice.studyId), false);
            return false;
        }
    }

    if (dataCheck.hasRecordings || subject.subjectId !== " ".repeat(10)) {
        const site = await VitaloJak2Api.ApiGetSite(device.id);
        const study = await VitaloJak2Api.ApiGetStudy(device.id);

        const unconfiguredSessions = await legacyClient.getUnconfiguredBySubjectId(subjectId);
        const isConfigured = unconfiguredSessions.filter(x => selectedSessions.map(ss => ss.id).includes(x.SessionScheduleId)).length === 0;

        const recordingsOnDevice = await VitaloJak2Api.ApiGetRecordings(device.id);
        if (recordingsOnDevice.length > 0) {

            const uploadRecordingCompletedFilters = [{
                Member: 'Id',
                Values: recordingsOnDevice.map(x => x.externalCode),
            }, {
                Member: 'UploadEndTime',
                Values: [null],
                Condition: QueryCondition.NotEqual,
            }];

            const completedCoughSessions = await legacyClient.getCoughSessions(uploadRecordingCompletedFilters);

            if (completedCoughSessions.Data.length === recordingsOnDevice.length) {

                return true;
            }
        }

        if ((hasForceReconfigurePermission) || (!dataCheck.hasRecordings)) {
            raiseConfigurationError(VitaloJak2Messages.ReconfigureAllowedWarning(subject.subjectId, site.siteId, study.studyId), true);
        } else if (isConfigured && !dataCheck.hasRecordings) {
            raiseConfigurationError(VitaloJak2Messages.ReconfigureConfiguredWithNoStudiesMessage(subject.subjectId, site.siteId, study.studyId), true);
        } else {
            raiseConfigurationError(VitaloJak2Messages.ReconfigureBlockedMessage(subject.subjectId, site.siteId, study.studyId), false);
            return false;
        }
    }

    return true;
}
